import { render, staticRenderFns } from "./ConfigPayments.vue?vue&type=template&id=75721aa8&"
import script from "./ConfigPayments.vue?vue&type=script&lang=js&"
export * from "./ConfigPayments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports